<template>
  <el-row class="page" :gutter="24" style="padding-right: 24px;">
    <el-col :span="18">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>База данных</span>
          <el-button @click="createNew()" type="primary" icon="el-icon-plus" circle style="float: right;"></el-button>
        </div>

        <el-tabs v-model="activeName">
          <el-tab-pane v-for="e of crudKeys" :key="e" :label="listsNames[e]" :name="e">
            <el-table v-if="lists[e] && lists[e][0]" :data="lists[e]" size="mini">
              <el-table-column width="60" prop="id">
                <template slot-scope="{ row }">
                  <el-button @click="edit(row)" icon="el-icon-edit" size="mini" type="warning" circle plain></el-button>
                </template>
              </el-table-column>
              <el-table-column
                v-for="c of Object.keys(cruds[e]).filter((t) => !cruds[e][t].hidden)"
                :key="c"
                :label="cruds[e][c].title"
                :prop="c"
                :width="cruds[e][c].width"
                :formatter="formatColumn"
              ></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-col>

    <el-dialog
      :title="listsNames[activeName]"
      :visible.sync="isShow"
      width="440px"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <el-form :model="form.data" label-width="110px" v-for="e of fieldKeys" :key="e" size="mini">
        <el-form-item v-if="form.fields[e].readonly !== true" :label="form.fields[e].title" style="text-align: left;">
          <el-input v-if="form.fields[e].type === 'text'" v-model="form.data[e]" type="text"></el-input>
          <el-input-number v-if="form.fields[e].type === 'number'" v-model="form.data[e]"></el-input-number>
          <el-switch
            v-if="form.fields[e].type === 'checkbox'"
            v-model="form.data[e]"
            :active-value="true"
            :inactive-value="false"
          ></el-switch>
          <el-select v-if="form.fields[e].type === 'list'" v-model="form.data[e]" style="width: 100%">
            <el-option
              v-for="option in lists[form.fields[e].list]"
              :key="option.id"
              :label="option.title"
              :value="option.id"
              >{{ option.title }}</el-option
            >
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button v-if="form.data.id" type="danger" @click="del" style="float: left">
          Удалить
        </el-button>
        <el-button @click="isShow = false">Отмена</el-button>
        <el-button type="primary" @click="save">{{ this.form.data.id ? "Сохранить" : "Добавить" }}</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import moment from "moment-timezone";
import { mapState } from "vuex";

moment.locale("ru");

export default {
  data: () => ({
    activeName: localStorage.activeTab ? localStorage.activeTab : "clients",
    isShow: false,
    form: {
      fields: {},
      data: {},
    },
  }),
  components: {},
  computed: {
    ...mapState(["lists", "cruds", "listsNames"]),
    crudKeys() {
      return Object.keys(this.cruds);
    },
    fieldKeys() {
      return Object.keys(this.form.fields);
    },
  },
  async created() {
    const crudPromises = [];
    for (const entity of this.crudKeys) {
      crudPromises.push(
        this.$axios
          .get(`/api/crud/${entity}`)
          .then((result) => {
            return this.$store.dispatch("updateList", {
              title: entity,
              list: result.data.data,
            });
          })
          .catch((e) => console.log(e))
      );
    }
    await Promise.all(crudPromises);
  },
  methods: {
    createNew() {
      this.form.data = {};
      this.form.fields = this.cruds[this.activeName];
      Object.keys(this.form.fields).forEach((e) => {
        let val = null;
        if (this.form.fields[e].type == "number") val = 0;
        if (this.form.fields[e].type == "text") val = "";
        if (this.form.fields[e].type == "checkbox") val = false;
        this.$set(this.form.data, e, val);
      });
      console.log(this.form.data);
      this.isShow = true;
    },
    edit(data) {
      console.log(data);
      this.form.data = {};
      this.form.fields = this.cruds[this.activeName];
      Object.keys(this.form.fields).forEach((e) => {
        this.$set(this.form.data, e, data[e]);
      });
      this.isShow = true;
    },
    save() {
      if (this.form.data.id == null) delete this.form.data.id;

      this.$axios
        .post(`/api/crud/${this.activeName}`, this.form.data)
        .then(() => this.$axios.get(`/api/crud/${this.activeName}`))
        .then((result) => {
          return this.$store.dispatch("updateList", {
            title: this.activeName,
            list: result.data.data,
          });
        })
        .catch((e) => console.log(e));
      this.isShow = false;
    },
    del() {
      this.$axios
        .delete(`/api/crud/${this.activeName}/${this.form.data.id}`)
        .then(() => this.$axios.get(`/api/crud/${this.activeName}`))
        .then((result) => {
          return this.$store.dispatch("updateList", {
            title: this.activeName,
            list: result.data.data,
          });
        })
        .catch((e) => console.log(e));
      this.isShow = false;
    },
    // eslint-disable-next-line no-unused-vars
    formatColumn(row, column, cellValue, index) {
      const prop = this.cruds[this.activeName][column.property];
      if (prop && prop.type == "list") {
        const rel = this.lists[prop.list].find((e) => e.id == cellValue);
        if (rel && rel.title) return rel.title;
      }
      return cellValue;
    },
  },
  mounted() {},
  watch: {
    activeName(newName) {
      localStorage.activeTab = newName;
    },
  },
};
</script>

<style scoped>
.box-card {
  margin-bottom: 25px;
}
</style>
